import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Identity, IdentityStorage } from 'storage-service-lib';
import { TipControllerService } from '../../../services/tip-controller.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent {
  private static readonly DEFAULT_TIP = ['Expand the width for more space'];

  @Input()
  loggedOut: boolean | undefined;

  @Output() onLogout = new EventEmitter<void>();

  tenantName = '';
  tips = FooterComponent.DEFAULT_TIP;
  isDefaultTip = true;

  constructor(identityStorage: IdentityStorage, tipControllerService: TipControllerService) {
    this.setTenantName(identityStorage.get());

    identityStorage.observe().subscribe((identity) => {
      if (identity) {
        this.setTenantName(identity);
      }
    });

    tipControllerService.tip$.subscribe((tip: string[] | undefined) => {
      if (!tip || tip.length === 0) {
        this.tips = FooterComponent.DEFAULT_TIP;
        this.isDefaultTip = true;
      } else {
        this.tips = tip;
        this.isDefaultTip = false;
      }
    });
  }

  logout(): void {
    this.onLogout.emit();
  }

  private setTenantName(identity: Identity | null): void {
    this.tenantName = identity ? identity.tenant : '';
  }
}
